import { useLayoutEffect, useState } from 'react';

import { SCREEN_SIZES } from '@/shared/Constants';

const useResponsive = () => {
	const [isMobile, setIsMobile] = useState(false);
	const [isTablet, setIsTablet] = useState(false);
	const [isDesktop, setIsDesktop] = useState(false);
	const [isLargeDesktop, setIsLargeDesktop] = useState(false);
	const [isPortrait, setIsPortrait] = useState(() => window.innerHeight > window.innerWidth);
	const [isLandscape, setIsLandscape] = useState(() => window.innerWidth >= window.innerHeight);
	const [isMobilePortrait, setIsMobilePortrait] = useState(false);
	const [isMobileLandscape, setIsMobileLandscape] = useState(false);
	const [isTabletPortrait, setIsTabletPortrait] = useState(false);
	const [isTabletLandscape, setIsTabletLandscape] = useState(false);

	useLayoutEffect(() => {
		function handleResize() {
			const width = window.innerWidth;
			const height = window.innerHeight;
			const portrait = height > width;
			const landscape = width >= height;

			// Device type based on width
			const mobile = width < SCREEN_SIZES.MOBILE;
			const tablet = width < SCREEN_SIZES.TABLET;
			const desktop = width >= SCREEN_SIZES.TABLET;
			const largeDesktop = width >= SCREEN_SIZES.DESKTOP;

			setIsMobile(mobile);
			setIsTablet(tablet);
			setIsDesktop(desktop);
			setIsLargeDesktop(largeDesktop);
			setIsPortrait(portrait);
			setIsLandscape(landscape);

			// Combined device + orientation states
			setIsMobilePortrait(mobile && portrait);
			setIsMobileLandscape(mobile && landscape);
			setIsTabletPortrait(tablet && portrait);
			setIsTabletLandscape(tablet && landscape);
		}

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return {
		isMobile,
		isTablet,
		isDesktop,
		isLargeDesktop,
		isPortrait,
		isLandscape,
		isMobilePortrait,
		isMobileLandscape,
		isTabletPortrait,
		isTabletLandscape,
	};
};

export default useResponsive;
